
export const couponStampRenealSteps = ['Data Programare', 'Resurse', 'Proceseaza', 'Completeaza'];
